import * as React from 'react'
import { Modal } from 'reactstrap'
import ReactSwitch from 'react-switch'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { Button } from 'components/Form'
import ColorPickerInput from 'components/ColorPickerInput'
import { categories as categoriesApi } from 'api'
import { getStaticImage } from 'utils/statics'
import { BrandsAndDelegations } from '../../Form'

const CategoriesDetail = (props) => {
  const {
    toggle,
    save,
    valuesToEdit,
    isSubmitting,
    displayAllValues,
    brands,
    delegations,
    onChangeBrands,
    onChangeDelegations,
    onChangeToggle,
    errorMessage = null,
    isEdit
  } = props

  const [category, setCategory] = React.useState({})
  const [operator, setOperator] = React.useState(null)
  const [categoryColor, setCategoryColor] = React.useState('#E87721')
  const [messageError, setMessageError] = React.useState(null)

  const [filterByOperator, setFilterByOperator] = React.useState(false)

  React.useEffect(() => {
    if (valuesToEdit._id) {
      categoriesApi.getById(valuesToEdit._id).then(({ data }) => {
        setCategory(data)
        setCategoryColor(data.color)
        setFilterByOperator(!!data.operator)
        setOperator(data.operator)
        onChangeBrands(data.brands)
        onChangeDelegations(data.delegations)
      }).catch(console.error)
    }
  }, [valuesToEdit])

  React.useEffect(() => {
    setMessageError(null)
  }, [brands, delegations, category])

  React.useEffect(() => {
    if (errorMessage) setMessageError(I18n.t('label_error_name_duplicate'))
  }, [errorMessage])

  const validator = (object) => {
    const required = ['name', 'color']
    for (const field of required) {
      if (!object[field] || !object[field].length) return { field, error: true }
    }
    return { error: false }
  }

  const onClick = () => {
    category.color = categoryColor
    if (!category || validator(category).error) {
      // cambiar etiqueta
      setMessageError(I18n.t('label_error_required_name'))
      return
    }
    if (!filterByOperator) {
      if (brands.length < 1) {
        setMessageError(I18n.t('dashboard_errors_you-must-select-brand'))
        return
      }
      if (delegations < 1) {
        setMessageError(I18n.t('dashboard_errors_you-must-select-delegation'))
        return
      }
      category['brands'] = brands
      category['delegations'] = delegations
    } else {
      category.forOperator = true
      category.operator = operator
    }
    save(category)
    setCategory({})
  }

  const onChange = (value, type) => {
    if (type === 'toggle') {
      setFilterByOperator(value)
      onChangeToggle(value)
      onChangeBrands([])
      onChangeDelegations([])
    }
    else if (type === 'brand') {
      onChangeBrands(value)
    }
    else if (type === 'delegation') {
      onChangeDelegations(value)
    }
  }

  return (
    <div className='categories-detail'>
      <Modal centered isOpen={props.isOpen} toggle={props.toggle} className={''} contentClassName={'modal-content-categories'}>
        <div className='modal-wrapper-header'>
          <h1>{category._id ? I18n.t('dashboard_edit-label') : I18n.t('dashboard_add-label')}</h1>
          <span onClick={props.toggle}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' />
          </span>
        </div>
        <legend dangerouslySetInnerHTML={{ __html: category._id ? I18n.t('labels_edit_label_legend') : I18n.t('labels_add_label_legend') }} />
        <div className='seccion-1'>
          <div className={`switch-section ${isEdit ? 'blocked-filter' : 'unblocked-filter'}`}>
            <ReactSwitch
              onChange={(value) => onChange(value, 'toggle')}
              checked={filterByOperator}
              onColor='#E87721'
              uncheckedIcon={false}
              checkedIcon={false}
              onHandleColor='#fff'
              width={50}
              height={25}
              className={'activated'}
            />
            <span>{I18n.t('dashboard_add-just-for-me')}</span>
          </div>
          <div className={filterByOperator ? 'blocked-filter' : 'unblocked-filter'}>
            <BrandsAndDelegations
              onChangeBrands={(value) => onChange(value, 'brand')}
              currentBrands={brands || []}
              onChangeDelegations={(value) => onChange(value, 'delegation')}
              currentDelegations={delegations || []}
              displayAllValues={displayAllValues}
            />
          </div>
        </div>
        <div className='section-detail'>
          <div className='section'>
            <label htmlFor='category'>{I18n.t('dashboard_label-name')}</label>
            <input id={'input-modal'} className='category-name' name='category' type='text' defaultValue={category.name} onChange={(value) => setCategory({ ...category, name: value.target.value })} />
          </div>
          <div className='section'>
            <label htmlFor='category-color'>{I18n.t('dashboard_label-color')}</label>
            <ColorPickerInput color={categoryColor} setColor={setCategoryColor} />
          </div>
        </div>
        <small className='error'>{messageError}</small>
        <div className='wrapper-buttons'>
          <Button
            secondary={true}
            value={I18n.t('dashboard_save')}
            onClick={onClick}
            isSubmitting={isSubmitting}
          />
          <Button
            value={I18n.t('dashboard_cancel')}
            onClick={toggle}
          />
        </div>
      </Modal >
    </div >
  )
}

export default CategoriesDetail
